<template>
  <v-menu :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon>
          mdi-dots-vertical
        </v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item v-if="!isRascunho(item)"
                   :disabled="!isEditavel(item) || bloquearEdicaoOuCopia"
                   @click="goToEditRequisicao(item)">
        <v-list-item-icon>
          <v-icon>mdi-pencil</v-icon>
        </v-list-item-icon>
        <v-list-item-content>Editar</v-list-item-content>
      </v-list-item>
      <v-list-item v-if="!isRascunho(item)"
                   :disabled="!hasRoleRequisicao || bloquearEdicaoOuCopia"
                   @click="onClickCopy(item)">
        <v-list-item-icon>
          <v-icon>mdi-content-copy</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          Copiar
        </v-list-item-content>
      </v-list-item>
      <px-cancelar-dialog
            :titulo="getTitulo"
            :descricao="getDescricao(item)"
            @cancelar-dialog="motivoRecusa => onClickCancelar(motivoRecusa, item)"
            :disabled="isCancelada(item) || !canCancelRequisicao(item)"
            v-if="!isRascunho(item) && hasRoleCompradorOuRequisicao"/>
      <v-list-item v-if="isRascunho(item)" @click="goToEditRequisicaoRascunho(item)">
        <v-list-item-icon>
          <v-icon>mdi-pencil</v-icon>
        </v-list-item-icon>
        <v-list-item-content>Editar rascunho</v-list-item-content>
      </v-list-item>
      <v-list-item v-if="isRascunho(item)" @click="onClickDelete(item)">
        <v-list-item-icon>
          <v-icon>mdi-delete</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          Remover rascunho
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <px-confirm-dialog ref="confirm"/>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';
import { SituacaoRequisicao, ErpCamposIntegracao } from 'px-business-components';

export default {
  props: {
    item: Object,
  },
  data() {
    return {
      loadingLink: false,
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador', 'hasRoleRequisicao']),
    ...mapGetters('entidade', ['erpCamposIntegracao']),
    isRascunho() {
      return item => SituacaoRequisicao.keys.RASCUNHO.key === item.situacao;
    },
    isEditavel() {
      return item => SituacaoRequisicao.keys.RECEBIDA.key === item.situacao
        && this.hasRoleRequisicao;
    },
    isCancelada() {
      return item => SituacaoRequisicao.keys.CANCELADA.key === item.situacao;
    },
    canCancelRequisicao() {
      return item => this.hasRoleComprador || (this.hasRoleRequisicao && this.isEditavel(item));
    },
    hasRoleCompradorOuRequisicao() {
      return this.hasRoleComprador || this.hasRoleRequisicao;
    },
    bloquearEdicaoOuCopia() {
      return this.erpCamposIntegracao === ErpCamposIntegracao.keys.SENIOR_MEGA.key;
    },
    getTitulo() {
      return 'Cancelar solicitação';
    },
    getDescricao() {
      return item => `A solicitação "${item.identificador}" será cancelada e a operação não poderá ser desfeita.`;
    },
  },
  methods: {
    emitUpdate() {
      this.$emit('update');
    },
    remove(item) {
      this.$emit('remove', item);
    },
    goToEditRequisicaoRascunho(item) {
      this.$router.push({
        name: 'main.requisicoes.edicao',
        params: {
          id: item.id,
          isRascunho: true,
          isCopy: false,
        },
      });
    },
    goToEditRequisicao(item) {
      this.$router.push({
        name: 'main.requisicoes.edicao',
        params: {
          id: item.id,
          isRascunho: false,
          isCopy: false,
        },
      });
    },
    onClickDelete(item) {
      this.$refs.confirm.open('Você deseja remover este rascunho?',
        'A solicitação será removida e esta operação não pode ser desfeita.',
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.remove(item);
        });
    },
    onClickCopy(item) {
      this.$router.push({
        name: 'main.requisicoes.cadastro',
        params: {
          id: item.id,
          isRascunho: false,
          isCopy: true,
        },
      });
    },
    onClickCancelar(motivoRecusa, item) {
      this.$emit('cancelar', item, { motivoRecusa });
    },
  },
};
</script>
